import { B100, B75, DN0, DN30, DN60, DN600, DN70, G200, G300, G400, N0, N20, N200, N70 } from '@atlaskit/theme/colors';
var colorMap = {
  light: {
    backgroundColorChecked: "var(--ds-background-boldSuccess-resting, ".concat(G400, ")"),
    backgroundColorCheckedHover: "var(--ds-background-boldSuccess-hover, ".concat(G300, ")"),
    backgroundColorCheckedDisabled: "var(--ds-background-disabled, ".concat(N20, ")"),
    backgroundColorUnchecked: "var(--ds-background-boldNeutral-resting, ".concat(N200, ")"),
    backgroundColorUncheckedHover: "var(--ds-background-boldNeutral-hover, ".concat(N70, ")"),
    backgroundColorUncheckedDisabled: "var(--ds-background-disabled, ".concat(N20, ")"),
    borderColorFocus: "var(--ds-border-focus, ".concat(B100, ")"),
    iconColorChecked: "var(--ds-text-onBold, ".concat(N0, ")"),
    iconColorDisabled: "var(--ds-text-disabled, ".concat(N70, ")"),
    iconColorUnchecked: "var(--ds-text-onBold, ".concat(N0, ")"),
    handleBackgroundColor: "var(--ds-background-default, ".concat(N0, ")"),
    handleBackgroundColorChecked: "var(--ds-background-default, ".concat(N0, ")"),
    handleBackgroundColorDisabled: "var(--ds-text-disabled, ".concat(N0, ")")
  },
  dark: {
    backgroundColorChecked: "var(--ds-background-boldSuccess-resting, ".concat(G300, ")"),
    backgroundColorCheckedHover: "var(--ds-background-boldSuccess-hover, ".concat(G200, ")"),
    backgroundColorCheckedDisabled: "var(--ds-background-disabled, ".concat(DN70, ")"),
    backgroundColorUnchecked: "var(--ds-background-boldNeutral-resting, ".concat(DN70, ")"),
    backgroundColorUncheckedHover: "var(--ds-background-boldNeutral-hover, ".concat(DN60, ")"),
    backgroundColorUncheckedDisabled: "var(--ds-background-disabled, ".concat(DN70, ")"),
    borderColorFocus: "var(--ds-border-focus, ".concat(B75, ")"),
    iconColorChecked: "var(--ds-text-onBold, ".concat(DN30, ")"),
    iconColorDisabled: "var(--ds-text-disabled, ".concat(DN30, ")"),
    iconColorUnchecked: "var(--ds-text-onBold, ".concat(DN600, ")"),
    handleBackgroundColor: "var(--ds-background-default, ".concat(DN600, ")"),
    handleBackgroundColorChecked: "var(--ds-background-default, ".concat(DN0, ")"),
    handleBackgroundColorDisabled: "var(--ds-text-disabled, ".concat(DN0, ")")
  }
};
export var getColors = function getColors(mode) {
  return colorMap[mode];
};